import apiFetch from '../apiFetch'

export default function (values, token) {
  return apiFetch({endPoint: `Analisis/obtenerDatosVerraco`, method: 'POST', body: values, token: token})
}